<template>
    <section id="page" 
        class="main-content-wrapper" 
        :class="formStyleClasses"
        v-bind:style="{'padding-top':idWndw || !$store.getters.showTopNavBar ? 0:''}">
        
        <template v-if="1 || !loading && $store.getters.getFormSchema(idWndw).id" >
            
            <slot name="formHeader"></slot>
            <loading v-if="loading"></loading> 
            <form-gen  
              v-if="!loading && $store.getters.getFormSchema(idWndw).id"
                ref="formGen" 
                :formSource="$store.getters.getFormSchema(idWndw)" 
                :loading="loading" 
                :idWndw="idWndw"
                :key="_uid">
            </form-gen>
            
            <slot name="formFooter"></slot>
            
        </template>
    </section>
</template>

<script>
    import {
        app,
        formService
    }
    from 'Js/feathers'
    // import _ from 'lodash'
    import { EventBus } from 'Js/eventBus';
    import { scriptService } from 'Js/feathers';
    import { actions } from 'Js/actionsProcessor';
    import { router } from 'Js/routes.js';
    import { getQueryParams } from 'Js/bfUtilities';
    import { TranslateJSON } from 'Js/bfUtilities';
    Vue.component('form-gen', require('./formGen/formgen.vue').default);
    import store from 'Js/store'
    import loadSiteFromNetwork from 'Js/store/modules/site.js';
    
    export default {

        name: "Form-Frame",

        methods: {
            fetchForm: function(id) {
                var _this = this, navSlug = getFormNavSlug(id), fetchingNetwork = false;
                // if there is a JWT around try to auth it before the call.
                return new Promise((resolve, reject) => this.$store.dispatch('CHECK_AUTH', true)
                    .then(async result => {
                        let params = {};
                        _this.$store.dispatch('ACTIONS_PAUSE', true );
                        params.query = _this.query ? _this.query : getQueryParams();
                        
                        var isOnline = store.getters.isOnline(), isAuthenticated = store.getters.isAuthenticated();
                        if (navSlug && isFormLocal(navSlug)) {
                            var _bfsite = JSON.parse(window.localStorage.getItem('_bfsite'));
                            if (!_bfsite.siteJSON.content.layouts[navSlug].formSchema.form.requestHook &&
                                (!_bfsite.siteJSON.content.layouts[navSlug].formSchema.form.authLevel ||
                                (!isOnline || isAuthenticated))) {
                                return _bfsite.siteJSON.content.layouts[navSlug].formSchema;
                            }
                        }
                        
                        if (isOnline) {
                            fetchingNetwork = true;
                            return formService.get(id, params);
                        }
                        
                        console.log('@formFetch site is offline')
                        throw {
                                  name: 'Unavailable',
                                  message: 'Check your internet connection.',
                                  code: 10902,
                                  className: 'User Offline'
                                };
                    })
                    .then(result => {
                        //if online - save it to LS
                        navSlug && _this.$store.getters.isOnline() && fetchingNetwork && !result.form.requestHook ? setFormLocally(navSlug, result) : null;
                        let translateResult = TranslateJSON(result, _this.idWndw)
                        var resultSetSiteApp = setSiteApp(_this, translateResult);
                        loadForm(_this, resultSetSiteApp);
                    })
                    .catch(e => {
                        if (e.message === 'No record found for id anonymous') {window.localStorage.removeItem('feathers-jwt'); location.reload(); return}
                        if (e.code == 401 && (this.$store.state.wndw.windows.length > 1)) EventBus.$emit("hideCardModal", {});
                        if (e.code == 404) {
                            return new Promise(async (resolve, reject) => {
                                var bfops = JSON.parse(window.localStorage.getItem('_bfsite'));
                                var hash = bfops && bfops.siteJSON && bfops.siteJSON.hash || '';
                                await loadSiteFromNetwork(resolve, reject, hash);
                            })
                        };
                        BF.errorThrow(e);
                    })
                );
            }
        },

        mounted() {
            // fetches form based on passed slug prop or routePath
            // TODO trap for bad form data
            let slug = this.urnSlug || this.$route.params.urnSlug
            if (slug) {
                let id = this.$store.state.site.content.layouts[slug].id
                this.fetchForm(id);
            }
            else {
                this.fetchForm(this.id);
            }
        },

        created() {},

        beforeMount() {},

        beforeDestroy() {},

        destroyed() {},
        
        computed: {
            formStyleClasses: function() {
                return this.loading ? '' : this.formSchema.form.styleClassesPage || 'flex-1'
            }
        },
        
        watch: {
            formSchema: {
                handler(val, oldVal) {
                },
                deep: true
            }

        },

        props: {
            id: String,
            storePath: String,
            urnSlug: String,
            idWndw: {
                type: Number,
                default: 0
            },
            model: null,
            query: null,
        },

        data: function() {
            return {
                formSchema: {},
                loading: true
            }
        }

    }
    
    function setSiteApp(_this, result) {
        if (result.code) { throw result }
        if (result.site) { _this.$store.commit('SET_SITE', result.site) }
        _this.$store.commit('SET_APP', result.app );
        delete result.app
        delete result.error;
        return result
    }
    
    function loadForm (_this, result) {
        result.options.idWndw = _this.idWndw 
        _this.idWndw ? result.model = Object.assign(result.model, _this.model) : null
        
        _this.$store.dispatch('UPDATE_WINDOW', {
            id: result.options.idWndw,
            formSchema: result
        });
        
        var pendingThreads = _this.$store.getters.pendingThreads;
        if (pendingThreads.length) {
            pendingThreads.forEach(idThread => {
                _this.$store.dispatch('ACTIONS_QUEUE', {idThread});
            });
            _this.$store.commit('CLEAR_PENDINGTHREADS');
        }
        
        _this.$store.dispatch('ACTIONS_QUEUE', result.actions); // added by script service
        delete result.actions
        if (_.get(result, 'form.namedActions.onFormLoad')) {
            result.form.namedActions.onFormload ? result.form.namedActions.onFormload.idForm = id : null;
            _this.$store.dispatch('ACTIONS_QUEUE', result.form.namedActions.onFormLoad); // onFormLoad
        }
        _this.formSchema = result
        result.state ? null : result.state = {}
        _this.loading = false
        _this.$store.dispatch('ACTIONS_PAUSE', false );
    }
    
    // TODO ask eduardo why calling from LS since that is performance what was the name of the hotel?
    function getFormNavSlug (formId) {
        var localBfSite = window.localStorage.getItem('_bfsite');
        if (localBfSite) {
            var localBfSiteObj = JSON.parse(localBfSite);
            
            for (const [key, value] of Object.entries(localBfSiteObj.siteJSON.content.layouts)) {
              if (value.id === formId) return key;
            }
        }
        return undefined;
    }
    
    function setFormLocally (navSlug, form) {
        var localBfSite = JSON.parse(window.localStorage.getItem('_bfsite'));
        _.set(localBfSite.siteJSON.content.layouts[navSlug], 'formSchema', form);
        window.localStorage.setItem('_bfsite', JSON.stringify(localBfSite));
    }
    
    function isFormLocal (navSlug) {
        var _bfsite = JSON.parse(window.localStorage.getItem('_bfsite'));
        
        if (_bfsite?.siteJSON?.content?.layouts?.[navSlug]?.formSchema) return true;
        return false;
    }
    
</script>

<style>
</style>
